export default () => ({
    loading: true,
    foods: null,
    currentFood: null,
    foodTypes: [],
    totalItems: 0,
    getTotalItemsParticipants: 0,
})